<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-2/5">
                            <label class="text-xs text-grey-darker" for="Classes">
                            Title
                        </label>
                        </div>
                        <div class="flex-grow w-3/5">
                            <app-field-text
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                name="title"
                                placeholder="Title"
                                v-model="element.object.values.title"
                            />
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Copy
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-cmp-trix-field
                            :classes="{ wrapper: { 'reset': true } }"
                            v-model="element.object.values.copy"
                        />
                    </div>
                </div>

                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-2/5">
                            <label class="text-xs text-grey-darker" for="Classes">
                            Sub title
                        </label>
                        </div>
                        <div class="flex-grow w-3/5">
                            <app-field-text
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                name="sub_title"
                                placeholder="Sub title"
                                v-model="element.object.values.sub_title"
                            />
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Sub copy
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-cmp-trix-field
                            :classes="{ wrapper: { 'reset': true } }"
                            v-model="element.object.values.sub_copy"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Start your conversation
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Enable
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.values.start_convo"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Image
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-full">
                        <label class="text-xs text-grey-darker">
                            Image
                        </label>
                        <app-field-file
                            class="reset mt-2"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.values.image"
                            :types="{images: true, files: false}"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Alt
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.alt"
                        />
                    </div>
                </div>

            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import ComposerTrixField from '@/components/composer/Fields/Trix';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import draggable from 'vuedraggable';

    import ColourField from '@/components/fields/inputs/Colour';
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import FileField from '@/components/fields/inputs/File';
    import SelectField from '@/components/fields/inputs/Select';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-colour-field': ColourField,
            'app-cmp-trix-field': ComposerTrixField,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-toggle-field': ToggleField,
            'app-field-file': FileField,
        },
        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data: () => ({
            fields: {
                title: {
                    name: 'Title',
                    attribute: 'title'
                },
                sub_title: {
                    name: 'Sub title',
                    attribute: 'sub_title'
                },
                link_text: {
                    name: 'Link text',
                    attribute: 'link_text'
                },
                link: {
                    name: 'Href/Link',
                    attribute: 'link'
                },
                target: {
                    name: 'Target',
                    attribute: 'target',
                    options: [
                        {
                            value: '_blank',
                            label: 'New window'
                        },
                        {
                            value: '_self',
                            label: 'Same window'
                        }
                    ]
                },
                image: {
                    name: 'Image',
                    attribute: 'image'
                },
                alt: {
                    name: 'Alt Text',
                    attribute: 'alt'
                },
                form_text: {
                    name: 'Form text',
                    attribute: 'form_text'
                },
                text: {
                    name: 'Text',
                    attribute: 'text'
                },
                size: {
                    name: 'Size',
                    attribute: 'size',
                    options: [
                        {
                            value: 'default',
                            label: 'Default'
                        },
                        {
                            value: 'sml',
                            label: 'Small'
                        },
                        {
                            value: 'md',
                            label: 'Medium'
                        },
                        {
                            value: 'lg',
                            label: 'Large'
                        },
                        {
                            value: 'xl',
                            label: 'Extra Large'
                        },
                    ]
                },
                width: {
                    name: 'Width',
                    attribute: 'width',
                    options: [
                        {
                            value: 'auto',
                            label: 'Auto'
                        },
                        {
                            value: 'full',
                            label: 'Full'
                        },
                    ]
                },
                shape: {
                    name: 'Shape',
                    attribute: 'shape',
                    options: [
                        {
                            value: 'pill',
                            label: 'Pill'
                        },
                        {
                            value: 'sqaure',
                            label: 'Sqaured'
                        },
                    ]
                },
                colour: {
                    name: 'Text Colour',
                    attribute: 'colour'
                },
                background: {
                    name: 'Background Colour',
                    attribute: 'background'
                },
                border: {
                    name: 'Border Colour',
                    attribute: 'border'
                },
                hover_colour: {
                    name: 'Text Colour',
                    attribute: 'hover_colour'
                },
                hover_background: {
                    name: 'Background Colour',
                    attribute: 'hover_background'
                },
                hover_border: {
                    name: 'Border Colour',
                    attribute: 'hover_border'
                },
                link: {
                    name: 'Href/Link',
                    attribute: 'link'
                },
                target: {
                    name: 'Target',
                    attribute: 'target',
                    options: [
                        {
                            value: '_blank',
                            label: 'New window'
                        },
                        {
                            value: '_self',
                            label: 'Same window'
                        }
                    ]
                },
            }
        }),

        methods: {
            add() {
                this.element.object.values.items.push({
                    'label': '',
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/BannerSixSettings.vue